import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../../common/Api";
import { list2tree } from "../../../common/Utils";
import { AuthResource, AuthResourceOpt } from "../../domains/AuthResource";
import { AuthRole } from "../../domains/AuthRole";
import { RoleEditStore } from "./RoleEditStore";

export class RolesStore {
  roles: AuthRole[] = [];
  resources: AuthResource[] = [];
  roleList: any[] = [];

  resTree: any[] = [];

  loading = false;
  edit: RoleEditStore;

  constructor() {
    makeAutoObservable(this, {});
    // this.refresh();
    this.edit = new RoleEditStore(this);
  }

  @action refresh() {
    this.loading = true;
    return Api.admin.role
      .roles()
      .then((res) => {
        runInAction(() => {
          this.roles = res.data.authRoles;
          const resources = res.data.authResources.sort((a: any, b: any) => b.sortOrder - a.sortOrder);
          const resTree = list2tree(resources, null);

          this.resources = resources;
          this.resTree = resTree;

          this.roleList = this.roles.map((role: any) => {
            const permissions = role.permissions.map((p) => {
              const { resId, optIds } = p;
              let opts: AuthResourceOpt[] = [];
              const res = this.resources.find((x: AuthResource) => x.code === resId);
              if (res) {
                opts = res.operations.filter((x: any) => optIds.includes(x.code));
              }

              return {
                resId,
                res,
                opts,
              };
            });
            return {
              ...role,
              permissions,
            };
          });
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }
}

export const rolesStore = new RolesStore();
